import { useState } from 'react';
import { emptyPropertyForm } from '../konstanter/siteConfig';
import { siteApi } from '../tjenester/siteApi';

const normalizePropertyType = (value) => {
  if (value === 'Leilighetsbygg') {
    return 'Leilighet';
  }

  if (value === 'Rekkehus') {
    return 'Rekkehus';
  }

  return value === 'Leilighet' || value === 'Hus' ? value : 'Hus';
};

function mapPropertyToForm(property) {
  const images = Array.isArray(property.images) && property.images.length > 0
    ? property.images
    : property.imageUrl
      ? [property.imageUrl]
      : [];

  return {
    name: property.name,
    address: property.address,
    type: normalizePropertyType(property.type),
    size: property.size,
    rentPerMonth: property.rentPerMonth || '',
    rooms: property.rooms || '',
    availableFrom: property.availableFrom,
    status: property.status,
    availability: property.availability,
    facilities: Array.isArray(property.facilities) ? property.facilities : [],
    summary: property.summary,
    imageUrl: images[0] || '',
    images,
  };
}

export function useAdminPropertyForm() {
  const [propertyForm, setPropertyForm] = useState(emptyPropertyForm);
  const [editingSlug, setEditingSlug] = useState('');
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [imageUploadError, setImageUploadError] = useState('');

  const beginEditingProperty = (property) => {
    setEditingSlug(property.slug);
    setPropertyForm(mapPropertyToForm(property));
  };

  const resetPropertyForm = () => {
    setEditingSlug('');
    setPropertyForm(emptyPropertyForm);
    setImageUploadError('');
  };

  const clearDeletedProperty = (slug) => {
    if (editingSlug === slug) {
      resetPropertyForm();
    }
  };

  const uploadPropertyImage = async (file) => {
    if (!file) {
      return;
    }

    setIsUploadingImage(true);
    setImageUploadError('');

    try {
      const { imageUrl } = await siteApi.uploadPropertyImage(file);
      setPropertyForm((current) => {
        const images = [...(current.images || []), imageUrl];
        return { ...current, images, imageUrl: images[0] };
      });
    } catch (error) {
      setImageUploadError(error.message || 'Klarte ikke laste opp bildet.');
    } finally {
      setIsUploadingImage(false);
    }
  };

  const removePropertyImage = (imageUrl) => {
    setImageUploadError('');
    setPropertyForm((current) => {
      const images = (current.images || []).filter((url) => url !== imageUrl);
      return { ...current, images, imageUrl: images[0] || '' };
    });
  };

  return {
    editingSlug,
    beginEditingProperty,
    clearDeletedProperty,
    imageUploadError,
    isUploadingImage,
    propertyForm,
    removePropertyImage,
    resetPropertyForm,
    setPropertyForm,
    uploadPropertyImage,
  };
}